import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

/**
 * ScrollContext
 *
 * Central abstraction for the active scroll container used by ScrollTrigger.
 * Components remain scroll-agnostic and always query this context instead of
 * knowing whether they live on the page or inside an overlay.
 *
 * The View / Overlay layer is responsible for updating the scroller when
 * scroll context changes (e.g. opening or closing an overlay).
 */
class ScrollContext {
	constructor() {
		this.scroller = window
	}

	setScroller(scroller) {
		this.scroller = scroller
		ScrollTrigger.refresh()
	}

	getScroller() {
		return this.scroller
	}
}

export const scrollContext = new ScrollContext()
